import { useSurveysQuery } from '../data-access';

export const useSurveysOpen = (partnerId: string) => {
	const {
		data: surveysOpenData,
		error: surveysOpenError,
		isLoading: isSurveysOpenLoading,
		refetch: refetchOpenSurveys
	} = useSurveysQuery({
		'details[]': ['surveyTranslations'],
		direction: 'asc',
		orderBy: 'closeAt',
		'partnerIds[]': [partnerId],
		'statuses[]': ['opened', 'scheduled']
	});

	return { isSurveysOpenLoading, refetchOpenSurveys, surveysOpenData, surveysOpenError } as const;
};
